// Componente de banner para invitar al operario a completar sus datos
// Importa componentes de Ionic y expone un botón único para ir a completar.

import React from 'react'; // Importamos React para poder definir el componente
import { IonCard, IonCardContent, IonButton, IonText } from '@ionic/react'; // Componentes de UI de Ionic

// Props que recibe el componente desde la página de Inicio
type Props = {
  // Lista de motivos a mostrar (qué falta completar)
  reasons: string[];
  // Acción que se ejecuta cuando el usuario decide completar sus datos ahora
  onEditar: () => void;
};

// Declaramos el componente funcional con sus propiedades tipadas
export const AlertActualizaDatos: React.FC<Props> = ({ reasons, onEditar }) => {
  // Retornamos la tarjeta de aviso con el contenido
  return (
    <IonCard color="warning"> {/* Tarjeta resaltada en color de advertencia */}
      <IonCardContent> {/* Contenedor del contenido textual y botones */}
        <IonText> {/* Bloque de texto principal */}
          <h2>Actualiza tus datos</h2> {/* Título del aviso */}
          {/* Mensaje único e informativo solicitado */}
          <p>
            Para mantener tu información al día, por favor completa tus datos personales. Deberia de hacerlo cuando estés en tu hogar para registrar correctamente tu ubicación.
          </p>
        </IonText>
        <div style={{ display: 'flex', gap: 8, marginTop: 8 }}> {/* Contenedor de botones */}
          <IonButton color="primary" onClick={onEditar}>Actualizar ahora</IonButton> {/* Único botón requerido */}
        </div>
      </IonCardContent>
    </IonCard>
  );
};
